import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-photos-configuration',
  templateUrl: './my-photos-configuration.component.html',
  styleUrls: ['./my-photos-configuration.component.css']
})
export class MyPhotosConfigurationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
